import { z } from "zod";

import {
  NEGATIVE_DISPLAY,
  POSITIVE_DISPLAY,
} from "@/encounters/components/EncounterLabor/flowsheet-forms/shared/labor-flowsheet-positive-negative-coding";
import { NO_DISPLAY, YES_DISPLAY } from "@/intake-forms/constants/yes-no-display";
import { zSignatureInitialsRequired } from "@/utils/zod";

const yesNoDisplayField = z.enum([YES_DISPLAY, NO_DISPLAY]).nullable().optional();
const positiveNegativeDisplayField = z
  .enum([POSITIVE_DISPLAY, NEGATIVE_DISPLAY])
  .nullable()
  .optional();

export const membranesFlowsheetFormSchema = z.object({
  examDate: z.date().nullable(),
  examTime: z.string().nullable(),
  fluidColor: z.string().nullable().optional(),
  fluidColorOther: z.string().optional(),
  pooling: yesNoDisplayField,
  nitrazine: positiveNegativeDisplayField,
  fernResults: positiveNegativeDisplayField,
  notes: z.string().optional(),
  signatureInitials: zSignatureInitialsRequired(),
});

export type MembranesFlowsheetFormSchemaType = z.infer<typeof membranesFlowsheetFormSchema>;
